import Lenis from "lenis";

let lenis = null;
let rafId = null;

export const initLenis = () => {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
        cancelAnimationFrame(rafId);
        if (lenis) lenis.destroy();
        lenis = null;
    };
};

export const stopLenis = () => lenis?.stop();
export const startLenis = () => lenis?.start();

export const scrollToId = (target) => {
    if (lenis) {
        lenis.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }
};
